import { Browser } from "@capacitor/browser";
import { Card, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { environmentConfig } from "@src/appV2/environment/config";
import { TextButton } from "@src/appV2/redesign/components/TextButton";

interface Props {
  title?: string;
  description?: string;
  buttonText?: string;
}

export function WorkplaceAppDownloadCard(props: Props) {
  const {
    title = "Trying to log in as a workplace user?",
    description = "You're on the app for professionals.",
    buttonText = "Download Clipboard Workplace",
  } = props;
  const hcfAppDynamicLink = environmentConfig.REACT_APP_HCF_APP_URL;

  return (
    <Card outlined variant="tertiary" sx={{ padding: 7, width: "100%" }}>
      <Stack spacing={6} sx={{ alignItems: "center" }}>
        <Stack spacing={2}>
          <Text semibold variant="h6">
            {title}
          </Text>
          <Text bold variant="body2">
            {description}
          </Text>
        </Stack>

        <TextButton
          underline
          onClick={async () => {
            await Browser.open({
              url: hcfAppDynamicLink,
              windowName: "_blank",
              presentationStyle: "popover",
            });
          }}
        >
          {buttonText}
        </TextButton>
      </Stack>
    </Card>
  );
}
